import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import Filter from './Filter'
import OrdersTable from './OrdersTable'
import { ContentBlock, ContentBlockLoading, ExpandableBlocks, ExpandableContext } from 'components/ContentBlock'
import { useSplittedQuery } from '../helpers'
import { getERPShopsWithoutDataStatistics } from 'sections/statistics/gql'
import { Row, Col } from 'react-flexbox-grid'
import DxDataTable from 'components/DxDataTable'

const ERPDate = ({ query }) => {
	const splittedPeriodRef = useRef([])
	const [getStatistics, { data, stitchedData, useStitchedData, loading, called }] = useSplittedQuery({ query, splittedPeriodRef })
	const [getStatisticsShop, { data: dataShop, loading: loadingShop, called: calledShop }] = useSplittedQuery({ query: getERPShopsWithoutDataStatistics })
	const [dataKey, setDataKey] = useState(Math.random())
	const [dataShopKey, setDataShopKey] = useState(Math.random())
	const [t] = useTranslation()

	const onGetData = setExpandedId => filterVals => {
		setExpandedId('2')
		setDataKey(Math.random())
		getStatistics({ variables: { params: filterVals } })
	}

	const onGetShops = setExpandedId => filterVals => {
		setExpandedId('3')
		setDataShopKey(Math.random())
		getStatisticsShop({ variables: { params: filterVals } })
	}

	return(
		<ExpandableBlocks>
			<ExpandableContext.Consumer>
				{({ setExpandedId }) => (
					<>
						<ContentBlock startExpanded label={t('common.strings.settings')}>
							<Filter
								onFilter={onGetData(setExpandedId)}
								onFilterShops={onGetShops(setExpandedId)}
								splittedPeriodRef={splittedPeriodRef}
							/>
						</ContentBlock>
						{called &&
							<ContentBlockLoading
								isLoading={loading}
								topBorder
								alwaysExpanded
								blockId='2'
							>
								<OrdersTable
									key={dataKey}
									data={useStitchedData ? stitchedData : data}
								/>
							</ContentBlockLoading>
						}
						{calledShop &&
							<ContentBlockLoading
								isLoading={loadingShop}
								topBorder
								alwaysExpanded
								blockId='3'
							>
								<Row>
									<Col xs={6}>
										<DxDataTable
											id='shopsTable'
											key={dataShopKey}
											data={dataShop}
											columns={[
												{
													caption: t('common.fields.code'),
													dataField: 'number',
													width: '75'
												},
												{
													caption: t('common.fields.name'),
													dataField: 'name',
													width: '225'
												}
											]}
											withSearch={false}
											label={t('statistic_section.strings.shop_data')}
										/>
									</Col>
								</Row>
							</ContentBlockLoading>
						}
					</>
				)}
			</ExpandableContext.Consumer>
		</ExpandableBlocks>
	)
}

export default ERPDate
